import type * as ngRouter from '@uirouter/angularjs';

export function isExplorerRoute(routeName: string) {
  return [
    'reportShow.noRuns.chart.view',
    'reportShow.runs.chart.view',
    'reportShow.noRuns.chart.explore',
    'reportShow.runs.chart.explore',
  ].includes(routeName);
}

export function isExploringVizOrExplorationRoute(routeName: string) {
  return typeof routeName === 'string' ? routeName.endsWith('.explore') : false;
}

/**
 * Return `true` for any route related to "exploring" or "explorations".
 */
export function isExplorationRoute(routerState: ngRouter.StateService): boolean {
  const routeMatchExplore =
    routerState.includes('**.explore') ||
    routerState.includes('**.view') ||
    routerState.includes('**.chart') ||
    routerState.includes('reportShow.noRuns.viz') ||
    routerState.includes('reportShow.runs.viz') ||
    routerState.includes('explorationShow.edit') ||
    routerState.includes('explorationShow.focus') ||
    routerState.includes('**.pythonviz') ||
    routerState.includes('**.pythonviz.view') ||
    routerState.includes('explorationShow.explore');

  return routeMatchExplore;
}

/**
 * Return `true` for any route related to dataset_reports.
 */
export function isDatasetsRoute(routerState: ngRouter.StateService): boolean {
  return routerState.includes('application.datasetReports.**');
}

export function isStandaloneVizPage(routeName: string) {
  const vizPageRouteStates = [
    'reportShow.noRuns.queries.details',
    'reportShow.noRuns.queries.data',
    'reportShow.runs.queries.details',
    'reportShow.runs.queries.data',
    'reportShow.noRuns.notebook',
  ];
  return isExplorerRoute(routeName) || vizPageRouteStates.includes(routeName);
}

export function isReportRoute(routeName: string) {
  return (
    routeName.startsWith('reportShow.runs') ||
    routeName.startsWith('reportShow.noRuns') ||
    routeName.startsWith('application.reports.edit.presentation')
  );
}

export function isReportViewerRoute(route: string): boolean {
  const reportViewerRoutes = ['reportShow.noRuns.dashboard', 'reportShow.runs.dashboard'];
  return reportViewerRoutes.includes(route);
}

export function isReportBuilderRoute(routeName: string): boolean {
  return routeName.includes('application.reports.edit.presentation');
}
